import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { Route as pathlessAuthenticatedRoute } from '../../../route';
import { EatonDspPage } from './EatonDspPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/item-master/utilities/eaton-dsp',
  staticData: {
    app: {
      access: {
        featureFlag: 'item-master-ui-enabled',
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Product }],
      },
    },
  },
  component: EatonDspPage,
  loader: () => ({
    crumb: msg('Eaton DSP Extract', { context: 'page breadcrumb' }),
  }),
});
